import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { apiBaseUrl } from "@/api/service";
import util from "@/libs/util.js";
export default {
  name: 'CompanyInfoDialog',
  props: {
    addForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    typeTags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    adminList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cityList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      apiBaseUrl: apiBaseUrl,
      innerVisible: false,
      localForm: _objectSpread({}, this.addForm),
      localFileList: [],
      localTypeTagsVal: [],
      disSubmit: false,
      addRules: {
        personCharge: [{
          required: true,
          message: '请选择负责人',
          trigger: 'blur'
        }],
        certificationType: [{
          required: true,
          message: '请选择认证类型',
          trigger: 'blur'
        }],
        certificationName: [{
          required: true,
          message: '请输入认证名称',
          trigger: 'blur'
        }],
        authNo: [{
          required: true,
          message: '请输入认证唯一编码',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          message: '请输入城市',
          trigger: 'blur'
        }],
        counterpart: [{
          required: true,
          message: '请输入对接人',
          trigger: 'blur'
        }],
        counterpartPhone: [{
          required: true,
          message: '请输入对接人手机号',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    addForm: {
      handler: function handler(v) {
        this.localForm = _objectSpread({}, v);
        // 初始化文件列表与标签选中
        this.localFileList = v.businessLicense && v.businessLicense.split(',').map(function (url) {
          return {
            name: url,
            url: url
          };
        }) || [];
        this.localTypeTagsVal = v.tagIds ? _toConsumableArray(v.tagIds) : [];
      },
      deep: true
    }
  },
  methods: {
    open: function open() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.localForm = _objectSpread({}, payload);
      this.localFileList = payload.businessLicense && payload.businessLicense.split(',').map(function (url) {
        return {
          name: url,
          url: url
        };
      }) || [];
      this.localTypeTagsVal = payload.tagIds ? _toConsumableArray(payload.tagIds) : [];
      this.innerVisible = true;
    },
    close: function close() {
      this.innerVisible = false;
    },
    onBeforeClose: function onBeforeClose(done) {
      this.localFileList = [];
      this.$emit('before-close');
      done && done();
    },
    onCancel: function onCancel() {
      this.close();
      this.onBeforeClose();
    },
    handleRemove: function handleRemove(file) {
      this.localFileList = this.localFileList.filter(function (i) {
        return i.uid !== file.uid;
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.$hevueImgPreview(file.url);
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.localFileList = fileList;
      } else {
        this.localFileList = fileList.filter(function (i) {
          return i.uid !== file.uid;
        });
        this.$message.error(res.msg);
      }
    },
    uploadChange: function uploadChange(file, fileList) {
      file.loading = !(file.response && file.response.code === 200);
    },
    onSubmit: function onSubmit() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var tags = [];
        if (_this.localTypeTagsVal.length > 0) {
          _this.typeTags.forEach(function (item) {
            if (_this.localTypeTagsVal.indexOf(item.id) > -1) {
              tags.push({
                tagId: item.id,
                tagName: item.ch
              });
            }
          });
        }
        var businessLicense = _this.localFileList.map(function (i) {
          return i.response ? i.response.data : i.url;
        }).toString();
        var submitForm = _objectSpread(_objectSpread({}, _this.localForm), {}, {
          tags: tags,
          businessLicense: businessLicense
        });
        _this.disSubmit = true;
        _this.$api.saveOrUpdateBqCompanyinfo(submitForm).then(function (res) {
          // 操作上报
          _this.$operationLog.push({
            operationType: 'quarter_company',
            code: submitForm.id ? 'edit' : 'add',
            detailBatchNo: res.data
          });
          _this.$message.success('操作成功');
          _this.disSubmit = false;
          _this.$emit('saved', res.data);
          _this.close();
          _this.onBeforeClose();
        }).catch(function (err) {
          _this.disSubmit = false;
        });
      });
    }
  }
};